// api/WikiPrintAPI.ts
import { registerQuery } from "@adornis/baseql/metadata/register.js";
import { createPDFFromComponent } from "@adornis/print/server/print-internals.js";
var componentMeta = {};
function unfoldTemplate(template, additional = {}) {
  if (!template) {
    return template;
  }
  for (const [key, value] of Object.entries(additional)) {
    template = template.replaceAll(`{{${key}}}`, value);
  }
  return template.replaceAll(
    "{{DATE}}",
    (/* @__PURE__ */ new Date()).toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric" })
  );
}
function processTemplates(meta, additional = {}) {
  return {
    ...meta,
    headerTemplate: unfoldTemplate(meta.headerTemplate, additional),
    footerTemplate: unfoldTemplate(meta.footerTemplate, additional)
  };
}
var WikiPrintAPI;
((WikiPrintAPI2) => {
  WikiPrintAPI2.setMeta = (component, meta) => {
    componentMeta[component] = meta;
  };
  WikiPrintAPI2.printPage = registerQuery({
    operationName: "printPage",
    type: () => String,
    resolve: (component, queryParams, fileName, templateMetaJSON) => async () => {
      const meta = componentMeta[component];
      return createPDFFromComponent({
        timeout: 3e4,
        component,
        queryParams,
        fileName,
        options: {
          ...processTemplates(meta ?? {}, JSON.parse(templateMetaJSON ?? "{}")),
          displayHeaderFooter: !!(meta?.headerTemplate || meta?.footerTemplate)
        }
      });
    },
    params: [
      { type: () => String, name: "component" },
      { type: () => String, name: "queryParams" },
      { type: () => String, name: "fileName" },
      { type: () => String, name: "templateMetaJSON" }
    ]
  });
})(WikiPrintAPI || (WikiPrintAPI = {}));
export {
  WikiPrintAPI
};
